import {Checkbox, Flex, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {stepsStore} from "../../../store/admissions/stepperStore";
import {achievements} from "../model/achievements";
import {resultStore} from "../../../store/admissions/admissionStore";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default function Step8() {
    const {result, setResult} = resultStore();
    const {stepsData, setStepsData} = stepsStore();
    const [selectDisable, setSelectDisable] = useState(false);
    const [selectNotAnyDisable, setSelectNotAnyDisable] = useState(false);
    const [selectedCount, setSelectedCount] = useState(0);
    const {xl} = useBreakpoint()

    useEffect(() => {
        if (!result.achievements) {
            setResult({
                ...result,
                achievements: achievements.get(result.kindsLevelFormation)?.reduce((acc: any, current: any) => ({
                    ...acc,
                    [current.code]: false
                }), {}),
            })
        } else {
            setStepsData({...stepsData, nextStep: true})
        }
    }, []);

    return (
        <Flex vertical style={{width: '100%'}} justify={"center"} align={"center"} gap={24}>
            <Flex vertical justify={"center"} align={"center"}>
                <Typography.Text strong style={{fontSize: 20}}>У меня есть достижения</Typography.Text>
                <Typography.Text>(можно выбрать несколько достижений)</Typography.Text>
            </Flex>
            <Flex vertical gap={16} style={{width: xl ? '50%' : '90%'}} justify={"center"}>
                {achievements.get(result.kindsLevelFormation)?.map((item: any, index: number) => (
                    <Checkbox
                        defaultChecked={result.achievements !== null && result.achievements[item.code]}
                        disabled={(selectDisable && item.code !== "notany") || (selectNotAnyDisable && item.code === "notany") || (result.achievements !== null && result.achievements["notany"] && item.code !== "notany")}
                        key={item.code}
                        onChange={(event) => {
                            setResult({
                                ...result,
                                achievements: {
                                    ...result.achievements,
                                    [item.code]: event.target.checked
                                }
                            })
                            if (item.code === "notany") {
                                setSelectDisable(event.target.checked);
                            } else {
                                setSelectedCount(selectedCount + (event.target.checked ? 1 : -1));
                                if (event.target.checked && selectedCount === 0) {
                                    setSelectNotAnyDisable(true);
                                } else if (!event.target.checked && selectedCount === 1) {
                                    setSelectNotAnyDisable(false);
                                }
                            }
                            setStepsData({...stepsData, nextStep: true})
                        }}>{item.display}</Checkbox>
                ))}
            </Flex>
        </Flex>
    )
}